module.exports = __webpack_public_path__ + "img/sdg3.95974cdd.svg";